const COUNT_CAP = 250;

export function formatCount(count: number): string {
    return count >= COUNT_CAP ? `${COUNT_CAP}+` : count.toLocaleString();
}
